// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import * as THREE from 'three'
// import Sky from 'three-sky'
// import * as OBJLoader from 'three-obj-loader';
// OBJLoader(THREE);

window.THREE = THREE;
import OrbitControls from "three/examples/js/controls/OrbitControls";

//
// (function() {
//   var script = document.createElement('script');
//   script.onload = function() {
//     var stats = new Stats();
//     document.body.appendChild(stats.dom);
//     requestAnimationFrame(function loop() {
//       stats.update();
//       requestAnimationFrame(loop)
//     });
//   };
//   script.src = '//rawgit.com/mrdoob/stats.js/master/build/stats.min.js';
//   document.head.appendChild(script);
// })()

Vue.use(VueResource)
Vue.config.productionTip = false
import './assets/styles/main.scss'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js